import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DateUtilService } from 'gung-common';

@Component({
    selector: 'otto-olsen-delete-saved-cart-modal',
    templateUrl: './otto-olsen-delete-saved-cart-modal.component.html',
    styleUrls: ['./otto-olsen-delete-saved-cart-modal.component.scss'],
    standalone: false
})
export class OttoOlsenDeleteSavedCartModalComponent implements OnInit {

  @Input()
  data: {
    date: Date,
    customer: string,
    name: string
  };

  constructor(
    public activeModal: NgbActiveModal,
    public dateUtilService: DateUtilService
  ) {

  }

  ngOnInit(): void {
  }

}
